/* J-Life Dawn refresh (HYA Media, Oct 2026)
   - Collection descriptions: the intro shows in full (never cut mid-sentence) and the rest opens with Read more
   - Swatch pickers: keep the selected colour/fabric name next to the option label */
(function () {
  function initDescriptions(root) {
    (root || document).querySelectorAll('[data-jl-desc]').forEach(function (desc) {
      if (desc.getAttribute('data-jl-ready')) return;
      desc.setAttribute('data-jl-ready', '1');

      var limit = parseInt(desc.getAttribute('data-jl-desc-limit') || '220', 10);
      /* Phones get a shorter intro so products show sooner */
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) limit = Math.min(limit, 120);
      var blocks = Array.prototype.filter.call(desc.children, function (el) {
        return el.textContent.trim() !== '' || el.querySelector('img, iframe, video');
      });

      var total = 0;
      var cut = -1;
      for (var i = 0; i < blocks.length; i++) {
        total += blocks[i].textContent.trim().length;
        if (total >= limit) {
          cut = i;
          break;
        }
      }
      if (cut < 0 || cut >= blocks.length - 1) return;

      var more = document.createElement('div');
      more.className = 'jl-desc__more';
      more.id = (desc.id || 'JlDescription') + '-more';
      more.setAttribute('data-jl-desc-more', '');
      more.hidden = true;
      for (var j = cut + 1; j < blocks.length; j++) more.appendChild(blocks[j]);
      desc.appendChild(more);

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'jl-desc__toggle';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', more.id);
      button.textContent = 'Read more';
      button.addEventListener('click', function () {
        var open = button.getAttribute('aria-expanded') === 'true';
        more.hidden = open;
        button.setAttribute('aria-expanded', open ? 'false' : 'true');
        button.textContent = open ? 'Read more' : 'Read less';
      });
      desc.parentNode.insertBefore(button, desc.nextSibling);
    });
  }

  function updateSwatchName(fieldset) {
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    var target = fieldset.querySelector('.jl-swatch-selected');
    if (checked && target) target.textContent = checked.value;
  }

  function initSwatches(root) {
    (root || document).querySelectorAll('.jl-swatch-fieldset').forEach(function (fieldset) {
      updateSwatchName(fieldset);
      if (fieldset.getAttribute('data-jl-ready')) return;
      fieldset.setAttribute('data-jl-ready', '1');
      fieldset.addEventListener('change', function () {
        updateSwatchName(fieldset);
      });
    });
  }

  function init(root) {
    initDescriptions(root);
    initSwatches(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Re-run when a section is re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
